var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoBrandCompetition = function SvgLogoBrandCompetition(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 245.6,
    height: 60.4,
    viewBox: "0 0 245.6 60.4",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.2,60.4c-.4,0-.7-.4-.7-.7V1.2c0-.4.4-.7.7-.7s.7.4.7.7v58.5c0,.4-.4.7-.7.7Z",
    style: {
      fill: "#005aaa",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40,50.4h-17.1c-.4,0-.7-.3-.7-.6l-1.7-16.2h0l-1.6,16.3c0,.4-.4.6-.7.6H.7c-.4,0-.7-.4-.7-.7s.4-.8.7-.8h16.6l1.6-15.7v-.2c0-.2.6-1.2,1.4-1.3.6,0,1.1.4,1.5,1.2v.3l1.6,15.7h16.5c.4,0,.7.4.7.7s-.3.8-.7.8h.1Z",
    style: {
      fill: "#005aaa",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.6,16.8c-.2-.3-.6-.5-.9-.5-.6,0-1,.5-1,1s0,.6.3.7l9.6,12,.4-.3-8.3-13h-.1Z",
    style: {
      fill: "#f06400",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3,28.3h-.4c-.6,0-1,.5-1,1s.4.9.8,1l9.7,2.3v-.4l-9.2-3.9h0Z",
    style: {
      fill: "#f06400",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,8c-.6,0-1,.5-1,1h0l.8,19.7h.5l.8-19.7h0c0-.6-.6-1-1.1-1Z",
    style: {
      fill: "#f06400",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1,18c0-.2.2-.4.2-.6,0-.6-.5-1-1-1s-.7.2-.9.5l-8.3,13,.4.3,9.6-12.1h0Z",
    style: {
      fill: "#f06400",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1,29.3c0-.6-.5-1-1-1s-.3,0-.4,0h0l-9.3,3.9v.4l9.8-2.3h0c.5,0,.8-.6.8-1h.1Z",
    style: {
      fill: "#f06400",
      strokeWidth: 0
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M69.6,17.6c0,3.4,2.7,4.7,5.7,4.7s5-.6,5-3.2-3.8-3.2-7.6-4.2-7.6-2.5-7.6-7.2,4.9-7.7,9.5-7.7,10.2,2.3,10.2,8.3h-5.5c-.2-3.2-2.3-4-5-4s-3.9.7-3.9,2.9,1.2,2.2,7.6,3.9c1.9.5,7.6,1.7,7.6,7.4s-3.7,8.2-10.6,8.2-10.9-2.8-10.8-9.1c0,0,5.4,0,5.4,0Z",
    style: {
      fill: "#005aaa",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4,7.6h4.8v2.3h0c1.2-1.9,3.2-2.9,5.5-2.9,5.7,0,8.3,4.6,8.3,9.9s-2.7,9.5-8.1,9.5-4.3-.9-5.6-2.8h0v8.7h-5.1V7.6h.2ZM102.1,16.8c0-3-1.2-5.9-4.4-5.9s-4.4,3-4.4,5.9,1.1,5.8,4.4,5.8,4.4-2.8,4.4-5.8",
    style: {
      fill: "#005aaa",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,13.2c.3-4.7,4.5-6.2,8.7-6.2s8.1.8,8.1,5.3v9.6c0,1.7.2,3.3.6,4.1h-5.1c-.2-.6-.3-1.2-.4-1.8-1.6,1.7-4,2.3-6.2,2.3-3.5,0-6.3-1.8-6.3-5.6s3.2-5.2,6.3-5.6c3.2-.4,6-.4,6-2.4s-1.5-2.5-3.2-2.5-3.2.7-3.3,2.8h-5.2ZM121.8,17c-.8.7-2.7.7-4.2,1.1s-3,.8-3,2.7,1.5,2.3,3.2,2.3c4,0,4.1-3.2,4.1-4.3v-1.9h0Z",
    style: {
      fill: "#005aaa",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.8,7.6h4.8v3.4h0c1-2.3,3.3-3.9,5.9-3.9s.7,0,1.1.2v4.7c-.6,0-1.2-.2-1.9-.2-3.7,0-5,2.7-5,5.9v8.3h-5.1V7.6h.2Z",
    style: {
      fill: "#005aaa",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.2,23.7h0c-1.2,1.9-3.3,2.9-5.7,2.9-5.6,0-8.3-4.8-8.3-9.9s2.8-9.5,8.2-9.5,4.4.9,5.5,2.8h0V.6h5.1v25.5h-4.8v-2.4ZM152.7,10.9c-3.3,0-4.4,2.9-4.4,5.9s1.3,5.9,4.4,5.9,4.4-3,4.4-5.9-1-5.9-4.4-5.9",
    style: {
      fill: "#005aaa",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.6,13.2c.3-4.7,4.5-6.2,8.7-6.2s8.1.8,8.1,5.3v9.6c0,1.7.2,3.3.6,4.1h-5.1c-.2-.6-.3-1.2-.4-1.8-1.6,1.7-4,2.3-6.2,2.3-3.5,0-6.3-1.8-6.3-5.6s3.2-5.2,6.3-5.6,5.9-.4,5.9-2.4-1.5-2.5-3.2-2.5-3.2.7-3.3,2.8c0,0-5.1,0-5.1,0ZM177.3,17c-.8.7-2.7.7-4.2,1.1-1.6.3-3,.8-3,2.7s1.5,2.3,3.2,2.3c4,0,4.1-3.2,4.1-4.3v-1.9h-.1Z",
    style: {
      fill: "#005aaa",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6,34.2h2.4v23.5h14.4v2h-16.8v-25.6h0Z",
    style: {
      fill: "#f06400",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7,51.2c0,.8,0,1.8.4,2.5.2.8.6,1.6,1.1,2.3s1.1,1.3,1.9,1.8,1.9.7,2.8.6c1.7,0,3-.5,3.9-1.3.9-.9,1.7-2.1,1.9-3.4h2.2c-.4,1.9-1.3,3.6-2.6,4.9-1.3,1.2-3.1,1.8-5.5,1.8s-2.6-.3-3.8-.8c-1-.5-1.9-1.2-2.6-2.1-.6-.9-1.2-2-1.5-3.2-.4-1.2-.5-2.5-.5-3.7s.2-2.4.5-3.6c.3-1.1.8-2.2,1.5-3.2s1.6-1.7,2.6-2.2,2.5-.9,3.8-.8c2.5,0,4.9,1.1,6.4,3.2.6,1,1.1,2.1,1.4,3.3.3,1.3.4,2.5.4,3.8h-14.3ZM96.7,49.4c0-.8-.2-1.7-.5-2.5-.3-.7-.6-1.5-1.2-2.1-.5-.6-1.1-1.1-1.9-1.5-2.3-1.2-5.1-.6-6.8,1.5-.6.6-.9,1.4-1.2,2.1-.3.8-.5,1.6-.6,2.4h12.2Z",
    style: {
      fill: "#f06400",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,59.8h-2v-3.3h0c-.6,1.2-1.5,2.2-2.6,2.9-1.1.6-2.4,1-3.8,1s-2-.2-3-.5c-.7-.3-1.5-.7-1.9-1.4-.6-.6-.9-1.4-1.1-2.2-.3-.9-.4-1.9-.4-3v-12.1h2.3v12.1c0,1.7.5,3,1.2,3.8s1.9,1.3,3.8,1.3,1.8-.2,2.5-.6c.7-.4,1.3-1,1.8-1.7s.8-1.6,1-2.4c.2-.9.4-1.9.3-2.7v-9.6h2.2l-.2,18.4h-.1Z",
    style: {
      fill: "#f06400",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.3,47.1c-.2-1.2-.8-2.4-1.8-3.2s-2.2-1.3-3.5-1.2c-1,0-1.9.2-2.9.6-.8.5-1.5,1-2,1.8-.6.7-.9,1.6-1.2,2.5-.6,1.9-.6,3.9,0,5.7s.6,1.8,1.2,2.5,1.2,1.4,2,1.8c.8.5,1.9.7,2.9.6.6,0,1.4,0,1.9-.4.6-.3,1.2-.6,1.7-1.1s.9-1,1.2-1.7.6-1.4.6-2.1h2.2c-.3,2.2-1.1,4-2.5,5.3s-3.2,1.9-5.2,1.9-2.6-.3-3.7-.8c-1-.5-1.9-1.2-2.8-2.1-.7-.9-1.3-1.9-1.7-3.1-.7-2.5-.7-5.1,0-7.5.4-1.1.9-2.2,1.7-3.2s1.7-1.6,2.8-2.1c1.2-.6,2.4-.8,3.7-.8s3.5.6,5,1.6c1.4,1,2.2,2.7,2.4,4.7l-2,.4h0Z",
    style: {
      fill: "#f06400",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.9,34.2h2.2v10.3h0c.2-.6.6-1.1.9-1.5.4-.5.8-.8,1.4-1.2.6-.4,1.1-.6,1.8-.7s1.3-.3,1.9-.3c1.1,0,2.2,0,3.2.5.8.3,1.6.7,2.1,1.4s.9,1.4,1.1,2.2c.2,1,.4,1.9.3,3v12h-2.2v-11.5c0-.7,0-1.5-.2-2.2,0-.6-.4-1.2-.7-1.8-.4-.6-.8-.9-1.5-1.2s-1.5-.5-2.3-.5-1.7.2-2.4.5c-.6.3-1.3.7-1.9,1.3-.6.6-.9,1.3-1.1,1.9-.3.8-.4,1.7-.5,2.5v10.8h-2.2v-25.4h0Z",
    style: {
      fill: "#f06400",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.8,41.4h3.8v1.9h-3.8v12.5c0,.6,0,1.2.3,1.8.2.5.7.6,1.5.7h1.9v1.9h-2c-1.5,0-2.6-.3-3.2-.9-.6-.6-.9-1.7-.8-3.2v-12.7h-3.2v-1.9h3.2v-5.6h2.2v5.6h.1Z",
    style: {
      fill: "#f06400",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.9,43.2h-3.7v16.6h-2.2v-16.6h-3.2v-1.9h3.2v-1.7c0-.7,0-1.5.2-2.2,0-.6.3-1.2.6-1.8.4-.5.8-.8,1.4-1.1.7-.3,1.5-.5,2.2-.4h1.9v2h-.8c-.3,0-.6-.2-.8-.2-.5,0-1,0-1.4.3-.3.2-.6.5-.7.7-.2.4-.3.7-.3,1.1v3h3.6v2.2Z",
    style: {
      fill: "#f06400",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.3,51.2c0,.8,0,1.8.4,2.5.2.8.6,1.7,1.1,2.3.5.7,1.1,1.3,1.9,1.8.8.5,1.9.7,2.8.6,1.7,0,3-.5,3.9-1.3.9-.9,1.7-2.1,1.9-3.4h2.2c-.4,1.9-1.3,3.6-2.6,4.9-1.3,1.2-3.1,1.8-5.5,1.8s-2.6-.3-3.8-.8c-1-.5-1.9-1.2-2.6-2.1s-1.2-2-1.5-3.2c-.4-1.2-.5-2.5-.5-3.7s.2-2.4.5-3.6c.3-1.1.8-2.2,1.5-3.2.6-.9,1.6-1.7,2.6-2.2s2.5-.9,3.8-.8c2.5,0,4.9,1.1,6.4,3.2.6,1,1.1,2.1,1.4,3.3.3,1.3.4,2.5.4,3.8h-14.3,0ZM193.3,49.4c0-.8-.2-1.7-.5-2.5-.3-.7-.6-1.5-1.1-2.1s-1.1-1.1-1.9-1.5c-1.6-.7-3.3-.7-4.9,0-.7.4-1.3.8-1.9,1.5-.6.6-.9,1.4-1.2,2.1-.3.8-.5,1.6-.6,2.4h12.1Z",
    style: {
      fill: "#f06400",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.6,59.8h-2v-3.3h0c-.6,1.2-1.5,2.2-2.6,2.9s-2.5,1-3.8,1-2-.2-3-.5c-.7-.3-1.5-.7-1.9-1.4-.6-.6-.9-1.4-1.1-2.2-.3-.9-.4-1.9-.4-3v-12.1h2.2v12.1c0,1.7.5,3,1.2,3.8s1.9,1.3,3.8,1.3,1.8-.2,2.5-.6c.7-.4,1.3-1,1.8-1.7s.8-1.6,1-2.4c.2-.9.3-1.9.3-2.8v-9.5h2.2v18.4h-.2Z",
    style: {
      fill: "#f06400",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.2,51.2c0,.8,0,1.8.4,2.5.2.8.6,1.6,1.1,2.3s1.1,1.3,1.9,1.8c.8.5,1.9.7,2.8.6,1.7,0,3-.5,3.9-1.3.9-.9,1.7-2.1,1.9-3.4h2.2c-.4,1.9-1.3,3.6-2.6,4.9-1.3,1.2-3.1,1.8-5.5,1.8s-2.6-.3-3.8-.8c-1-.5-1.9-1.2-2.6-2.1-.6-.9-1.2-2-1.5-3.2-.4-1.2-.5-2.5-.5-3.7s.2-2.4.5-3.6c.3-1.1.8-2.2,1.5-3.2.6-.9,1.6-1.7,2.6-2.2s2.5-.9,3.8-.8c2.5,0,4.9,1.1,6.4,3.2.6,1,1.2,2.1,1.4,3.3.3,1.3.4,2.5.4,3.8h-14.4.1ZM231.2,49.4c0-.8-.2-1.7-.5-2.5-.3-.7-.6-1.5-1.2-2.1-.5-.6-1.1-1.1-1.9-1.5-.7-.4-1.6-.6-2.4-.6s-1.7.2-2.5.6c-.7.4-1.3.8-1.9,1.5-.6.6-.9,1.4-1.2,2.1-.3.8-.5,1.6-.6,2.4h12.2Z",
    style: {
      fill: "#f06400",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.5,41.4h2v4.4h0c.5-1.4,1.5-2.6,2.7-3.5,1.3-.8,2.8-1.2,4.4-1.1v2.2c-.9,0-1.9,0-2.8.4-1.7.6-3,1.9-3.6,3.5-.4.8-.5,1.8-.5,2.7v9.8h-2.2v-18.4h0Z",
    style: {
      fill: "#f06400",
      strokeWidth: 0
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoBrandCompetition);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-brand-competition.fa8fccc4518c59a5b5f4761bac44d454.svg";